// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608031204/js/" + chunkId + "." + {"44":"95ecdb37","225":"f3e07358","481":"ebe26635","486":"db00cfbe","770":"440f60a7"}[chunkId] + ".0.257183584665733.chunk.js";
};